module.exports = __webpack_public_path__ + "static/media/review-card-texture.8b32489b.png";